import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * RoleRoute - gate a route group by account role.
 *   allow="super_admin": only operators (anonymous -> /login, customers -> /dashboard)
 *   allow="customer":    only customers, or an operator viewing as one (operators -> /admin)
 */
const RoleRoute = ({ allow, children }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: 'var(--text-secondary)' }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const isOperator = user?.role === 'super_admin';
  const viewing = !!user?.impersonating;

  if (allow === 'super_admin') {
    return isOperator && !viewing ? children : <Navigate to="/dashboard" replace />;
  }
  if (allow === 'customer') {
    return isOperator && !viewing ? <Navigate to="/admin" replace /> : children;
  }
  return children;
};

export default RoleRoute;
